import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const StratifiedProductionChartsDataContext = createContext();

const StratifiedProductionChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.PRODUCTION_STRATIFIED_PRODUCTION,
            url: 'governanceroom/esus/production/stratifiedproduction'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            service_type: filters.service_type_stratified.value,
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  totalServices: data?.indicators?.totalServices ?? 0
              },
              annualEvolutionServices: data?.annualEvolutionServices ?? [],
              monthlyEvolutionServices: data?.monthlyEvolutionServices ?? [],
              servicesByAge: data?.servicesByAge ?? [],
              servicesBySex: data?.servicesBySex ?? []
          }
        : {
              indicators: {
                  totalServices: 0
              },
              annualEvolutionServices: [],
              monthlyEvolutionServices: [],
              servicesByAge: [],
              servicesBySex: []
          };

    return (
        <StratifiedProductionChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </StratifiedProductionChartsDataContext.Provider>
    );
};

export default StratifiedProductionChartsDataProvider;
